import { DynamicDictionary } from '@shared/types';
import { createContext } from 'react';

const i18nStringsContext = createContext<DynamicDictionary>({});

export default i18nStringsContext;
